module.exports = function() {
  return new Worker(__webpack_public_path__ + "a82f801c9168af98ae12.worker.js");
};